export default __webpack_public_path__ + "aba3677f3b7a5f6d795eaa3645cea3c8.jpg";